import type {
  UiState,
  UiStateKeys,
  ElementType,
  NonEmptyArray,
} from '../types';

type KeyOrKeys = UiStateKeys | NonEmptyArray<UiStateKeys>;

export function getUiState<T extends KeyOrKeys>(keyOrKeys: T) {
  type ReturnType = T extends UiStateKeys[]
    ? {
      [N in ElementType<typeof keyOrKeys>]: UiState[N]
    }
    : UiState[typeof keyOrKeys];

  return <U extends UiState>({ ui }: { ui: U }): ReturnType => {
    if (Array.isArray(keyOrKeys)) {
      return keyOrKeys.reduce(
        (acc, key: UiStateKeys) => ({
          ...acc,
          [key]: ui[key],
        }),
        {},
      );
    }

    return ui[keyOrKeys];
  };
}

export const getFeatures = (state) => state.ui.namespace.settings.features;
